import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { BRAND_PILLARS } from '../data/products';
import { reveal, registerScrollTrigger } from '../lib/motion';

const PillarCard = ({ pillar, index }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    registerScrollTrigger();
    const ctx = gsap.context(() => {
      reveal(cardRef.current,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0, duration: 0.9, ease: 'power2.out',
          scrollTrigger: { trigger: cardRef.current, start: 'top 88%', toggleActions: 'play none none none' },
          delay: (index % 3) * 0.12,
        }
      );
    }, cardRef);
    return () => ctx.revert();
  }, [index]);

  return (
    <div
      ref={cardRef}
      data-testid={`pillar-card-${index + 1}`}
      className="pillar-card"
      style={{ opacity: 0 }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '18px' }}>
        <div style={{ width: '1px', height: '32px', background: 'var(--gold)', flexShrink: 0, marginTop: '4px' }} />
        <h3 style={{ fontFamily: 'Cinzel', fontStyle: 'normal', fontSize: '15px', letterSpacing: '3px', textTransform: 'uppercase', color: 'var(--cream)', fontWeight: 400 }}>
          {pillar.title}
        </h3>
      </div>
      <p style={{ fontFamily: 'Cormorant Garamond', fontStyle: 'italic', fontSize: '17px', color: 'var(--grey)', lineHeight: 1.7 }}>
        {pillar.desc}
      </p>
    </div>
  );
};

const WhyMaisonVael = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    registerScrollTrigger();
    const ctx = gsap.context(() => {
      reveal(titleRef.current,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1.1, ease: 'power2.out', scrollTrigger: { trigger: titleRef.current, start: 'top 80%' } }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section
      id="why"
      ref={sectionRef}
      data-testid="why-section"
      className="section-pad"
      style={{ background: 'var(--deep-warm-black)' }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

        <div ref={titleRef} style={{ opacity: 0, marginBottom: '80px' }}>
          <span className="section-eyebrow">04 — Philosophy</span>
          <h2 style={{ fontFamily: 'Cinzel', fontStyle: 'normal', fontSize: 'clamp(28px, 4.5vw, 52px)', letterSpacing: '5px', color: 'var(--cream)', fontWeight: 400, marginTop: '18px', maxWidth: '600px' }}>
            Why Maison Vael
          </h2>
          <p style={{ fontFamily: 'Cormorant Garamond', fontStyle: 'italic', fontSize: '19px', color: 'var(--grey)', lineHeight: 1.8, maxWidth: '480px', marginTop: '20px' }}>
            Six principles that define every bottle we produce.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2px' }}>
          {BRAND_PILLARS.map((pillar, i) => (
            <PillarCard key={i} pillar={pillar} index={i} />
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyMaisonVael;
